// import React, { useState } from "react";
// import { useObserver } from "mobx-react";
// import { AiFillCloseCircle, AiOutlineUpload } from "react-icons/ai";
// import { useStores } from "../../../store";
// import { useNavigate } from "react-router-dom";
// import Loader from "../../reusble_components/loader";
// import popup from '../../../assests/VerifyPopup.png';
// export default function VerifyPopup(props) {
//   const { PopupStore, UserStore, RecuiterStore } = useStores();
//   const navigate = useNavigate();
//   const [form, setform] = useState(false);
//   const [fileName1, setFileName1] = useState("");
//   const [url, seturl] = useState("");
//   const [loader, setLoader] = useState(false);

//   const closeThisPopUP = () => {
//     setform(false);
//     setFileName1("");
//     seturl("");
//     PopupStore.setClient(false);
//   };


//   return useObserver(() => (
//     <>
//       {true ? (
//         <div className="absolute w-screen h-screen z-50 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40">
//           <div className="fixed pt-[4%] pb-[3%] inset-0 bg-bg3 z-50 flex flex-col justify-center rounded-3xl items-center md:w-[60%] lg:w-[80%] w-[90%] h-[80%] md:h-[70%] lg:h-[60%] m-auto shadow-lg overflow-y-auto no-scrollbar">
//             <div className="flex flex-col  items-center  h-full p-5 w-[100%] md:w-[100%] lg:[100%] ">
//               <Loader loader={loader} />
//               <AiFillCloseCircle
//                 className="text-primary absolute text-2xl cursor-pointer top-3 right-3"
//                 onClick={closeThisPopUP}
//               />
//               <div className="w-[45%] lg:w-[50%] md:w-[40%] h-auto">
//                 <img src={popup} alt="" />
//               </div>
//               <div className="text-4xl px-[4%] py-[1%] md:text-4xl lg:text-6xl font-medium font-Poppins">
//                 <h1 className=" md:mx-[2%]">
//                     <span className="text-primary">Oops!</span> Your account is not verified yet
//                 </h1>
//                 <p className="text-[1.35rem] py-[1%] -mx-[2.5%] md:text-2xl lg:text-4xl font-normal">
//                     Please wait until your account is verified to unlock all the  features !
//                 </p>
//               </div>
//             </div>
//             <div>
//                 <p>Having trouble? <a href="#" className="text-primary">Contact us!</a></p>
//             </div>
//           </div>
//         </div>
//       ) : null}
//     </>
//   ));
// }
import React, { useState } from "react";
import { useObserver } from "mobx-react";
import { AiFillCloseCircle } from "react-icons/ai";
import { useStores } from "../../../store";
import Loader from "../../reusble_components/loader";
import popup from '../../../assests/VerifyPopup.png';

export default function VerifyPopup() {
  const { PopupStore } = useStores();
  const [form, setForm] = useState(false);
  const [fileName1, setFileName1] = useState("");
  const [url, setUrl] = useState("");
  const [loader, setLoader] = useState(false);

  const closeThisPopUP = () => {
    setForm(false);
    setFileName1("");
    setUrl("");
    PopupStore.setVerify(false);
  };

  return useObserver(() => (
    <>
      {PopupStore.verify ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
          <div className="relative bg-white rounded-2xl shadow-lg p-8 w-[90%] md:w-[60%] lg:w-[60%]">
            <AiFillCloseCircle
              className="absolute top-3 right-3 text-2xl text-primary cursor-pointer"
              onClick={closeThisPopUP}
            />
            <Loader loader={loader} />
            <div className="flex flex-col items-center">
              <img src={popup} alt="Verification Pending" className="w-[50%] mb-6" />
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-center">
                <span className="text-primary">Oops!</span> Your account is not verified yet
              </h1>
              <p className="text-lg md:text-xl lg:text-2xl font-normal text-center mt-4">
                Please wait until your account is verified to unlock all the features!
              </p>
            </div>
            <div className="mt-8 text-center">
              <p>Having trouble? <a href="mailto:connect@reaidy.io" className="text-primary underline">Contact us!</a></p>
            </div>
          </div>
        </div>
      ) : null}
    </>
  ));
}
